import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';

import RichEditorContent from 'components/RichEditorContent';
import DataId from 'components/DataId';

import ClosedChatHistory from 'components/modals/ClosedChatHistory';

import AbstractTimelineEvent from './AbstractTimelineEvent';

class TimelineCustomerChat extends AbstractTimelineEvent {
  constructor(props) {
    super(props);

    this.state = {
      showDetails: false,
    };
  }

  showDetails = () => {
    this.setState({ showDetails: true });
  };

  closeDetails = () => {
    this.setState({ showDetails: false });
  };

  getChatDetails = () => {
    const { customerChat } = this.props;
    const customerChatId = this.getParam('customerChatId');
    return customerChat[customerChatId] ? customerChat[customerChatId] : { pending: true };
  };

  render() {
    const {
      intl: { messages },
      event,
    } = this.props;
    const { showDetails } = this.state;

    const chatDetails = this.getChatDetails();
    const customerChatId = this.getParam('customerChatId');

    return (
      <div className="card-block">
        <RichEditorContent content={'<div>' + event.getText() + '</div>'} />

        <div className="p-t-10">
          <DataId
            dataIdName="customerChat"
            dataIdId={customerChatId}
            url={`/api/customerchats/${customerChatId}.json`}
          />

          {chatDetails.pending ? (
            <>
              <i className="fas fa-circle-notch fa-spin" />
            </>
          ) : (
            <>
              <div className="m-t-10">
                <dl>
                  <dt>{messages.employee}</dt>
                  <dd>
                    {chatDetails.data.customer_chat &&
                      chatDetails.data.customer_chat.public_creator &&
                      chatDetails.data.customer_chat.public_creator.name}
                  </dd>

                  <dt className="m-t-5">{messages.client}</dt>
                  <dd>{chatDetails.data.customer_chat.target_name}</dd>

                  <dt className="m-t-5">{messages.email}</dt>
                  <dd>{chatDetails.data.customer_chat.target_email}</dd>
                </dl>
              </div>

              <div className="m-t-10">
                <Button onClick={this.showDetails}>
                  <i className="fa fa-eye" /> {messages.view}
                </Button>
              </div>

              <ClosedChatHistory show={showDetails} close={this.closeDetails} chatDetails={chatDetails} />
            </>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    customerChat: state.dataId.customerChat,
  };
};

export default injectIntl(connect(mapStateToProps)(TimelineCustomerChat));
